/**
 * Приложения платформы для 3D куб-карусели.
 * Скриншоты лежат в public/shots/ (живые экраны production-приложений,
 * снятые Playwright'ом при viewport 390×844). Базовый путь /landing/
 * подставляется через import.meta.env.BASE_URL.
 *
 * Тексты (name/role/desc) — в i18n словарях: t.apps.items[id].
 */

export type AppId =
  | "guest"
  | "kitchen"
  | "cashier"
  | "waiter"
  | "admin"
  | "booking";

export interface CubeApp {
  id: AppId;
  /** Имя файла скриншота в public/shots/ */
  shot: string;
  /** Номер для счётчика на грани */
  index: number;
}

export const CUBE_APPS: CubeApp[] = [
  { id: "guest", shot: "guest.jpg", index: 1 },
  { id: "kitchen", shot: "kitchen.jpg", index: 2 },
  { id: "cashier", shot: "cashier.jpg", index: 3 },
  { id: "waiter", shot: "waiter.jpg", index: 4 },
  { id: "admin", shot: "admin.jpg", index: 5 },
  { id: "booking", shot: "booking.jpg", index: 6 },
];

export function shotUrl(shot: string): string {
  return `${import.meta.env.BASE_URL}shots/${shot}`;
}

/** Всего приложений на платформе (включая склад/курьера/закупки). */
export const TOTAL_APPS = 10;
